import React from 'react';
import { injectIntl } from 'react-intl';
import { CopyToClipboard as CTC } from 'react-copy-to-clipboard';
import { Overlay, Tooltip } from 'react-bootstrap';

class CopyToClipboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      copied: false,
    };

    this.iconRef = React.createRef();
  }

  onCopy = () => {
    this.setState({ copied: true }, () => {
      this.timeout = setTimeout(this.hideCopied, 1500);
    });
  };

  hideCopied = () => {
    this.setState({ copied: false });
  };

  componentWillUnmount = () => {
    clearTimeout(this.timeout);
  };

  render() {
    const {
      intl: { messages },
      text,
      className,
    } = this.props;
    const { copied } = this.state;

    return (
      <React.Fragment>
        <CTC text={text} onCopy={this.onCopy}>
          <i className={className + ' fal fa-copy cursor ' + (copied ? 'text-primary ' : '')} ref={this.iconRef} />
        </CTC>
        <Overlay show={copied} target={this.iconRef.current} placement="top">
          <Tooltip>{'copied'}</Tooltip>
        </Overlay>
      </React.Fragment>
    );
  }
}
CopyToClipboard.defaultProps = {
  className: 'm-l-10',
};

export default injectIntl(CopyToClipboard);
